import { ulid } from "ulid";
import { ITriggerData, ITriggerJavaData, ITriggerShellData, createTriggerUtils } from "../../../trigger";
import { timeNamespace } from "../time-namespace";
import { UI } from "./UI";

const type = `${timeNamespace}timeout`
export interface ITriggerTimeoutJavaData extends ITriggerJavaData{
    timeout:number
}
export interface ITriggerTimeoutData extends ITriggerData<ITriggerShellData, ITriggerTimeoutJavaData>{
}

function createDefultData():ITriggerTimeoutData{
    return {
        id:ulid(),
        type,
        javaData:{
            timeout:0
        }
    }
}

function init(){
    
}

export const triggerTimeoutUtils = createTriggerUtils(type, init, createDefultData, UI)


